var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FFE206"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5787 7.66699H10.4121C6.90122 7.66699 5.92039 8.51033 5.83789 11.792C7.60706 11.792 9.03706 13.2312 9.03706 15.0003C9.03706 16.7695 7.60706 18.1995 5.83789 18.2087C5.92039 21.4903 6.90122 22.3337 10.4121 22.3337H19.5787C23.2454 22.3337 24.1621 21.417 24.1621 17.7503V12.2503C24.1621 8.58366 23.2454 7.66699 19.5787 7.66699Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2441 7.66699V10.8753",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2441 19.125V22.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.773 12.553L18.3413 13.6988C18.3963 13.8088 18.5063 13.8913 18.6255 13.9096L19.8905 14.093C20.2022 14.1388 20.3305 14.5238 20.1013 14.7438L19.1847 15.633C19.093 15.7155 19.0563 15.8438 19.0747 15.9721L19.2947 17.228C19.3497 17.5396 19.0197 17.778 18.7447 17.6313L17.6172 17.0355C17.5072 16.9805 17.3697 16.9805 17.2597 17.0355L16.1322 17.6313C15.848 17.778 15.5272 17.5396 15.5822 17.228L15.8022 15.9721C15.8205 15.8438 15.7838 15.7246 15.6922 15.633L14.7847 14.7438C14.5555 14.5238 14.6838 14.1388 14.9955 14.093L16.2605 13.9096C16.3888 13.8913 16.4897 13.818 16.5447 13.6988L17.1038 12.553C17.2322 12.2688 17.6355 12.2688 17.773 12.553Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/GiftCard.e3d55fc4274e70bf3fd5ca8dc5885a08.svg";
export { ForwardRef as ReactComponent };